const icon = {
  prefix: 'fac',
  iconName: 'calendar',
  icon: [512, 512, [], null, 'M156.25,187.5h62.5V250h-62.5V187.5z M250,187.5h62.5V250H250V187.5z M343.75,187.5h62.5V250h-62.5V187.5z   M62.5,375H125v62.5H62.5V375z M156.25,375h62.5v62.5h-62.5V375z M250,375h62.5v62.5H250V375z M156.25,281.25h62.5v62.5h-62.5  V281.25z M250,281.25h62.5v62.5H250V281.25z M343.75,281.25h62.5v62.5h-62.5V281.25z M62.5,281.25H125v62.5H62.5V281.25z M406.25,0  v31.25h-62.5V0H125v31.25H62.5V0H0v500h468.75V0H406.25z M437.5,468.75H31.25V125H437.5V468.75z'],
}

export const prefix = 'fac'

export const definition = icon

export const facCalendar = icon
